module.exports = __webpack_public_path__ + "static/media/Siplin.8d1b3488.jpg";